//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ediDestinations', {
//        templateUrl: 'views/components/views/ediDestinations/ediDestinations.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ediExportService', function (stateService, ediExportService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//    			itemsListEdiDestinations: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdiDestinations() {
//                vm.model.itemsListEdiDestinations = await ediExportService.listEdiDestinations();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'edidestination':
//                        go({ edi_destination_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdiDestinations();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
